// src/beta/routes.tsx
import { Routes, Route } from 'react-router-dom';
import { Catalog } from '@/beta/pages/Catalog';
import { Focus } from '@/beta/pages/Focus';
import { Scrubber } from '@/beta/pages/Scrubber';
import { Dossier } from '@/beta/pages/Dossier';
import { StoryReader } from '@/beta/pages/StoryReader';

/** Beta route table.
 *  Phase C: Catalog at /beta.
 *  Phase D: Focus.
 *  Phase E: Scrubber at /showcase/:id/scrub.
 *  Phase F: Dossier at /showcase/:id/dossier.
 *  Phase G: StoryReader at /showcase/:id/stories/:storyId. */
export function BetaRoutes() {
  return (
    <Routes>
      <Route path="/" element={<Catalog />} />
      <Route path="/showcase/:vehicleId" element={<Focus />} />
      <Route path="/showcase/:vehicleId/scrub" element={<Scrubber />} />
      <Route path="/showcase/:vehicleId/dossier" element={<Dossier />} />
      <Route path="/showcase/:vehicleId/stories/:storyId" element={<StoryReader />} />
      <Route path="*" element={<Catalog />} />
    </Routes>
  );
}
